import { useBatchImportCouriersAction } from './batch-import-couriers-action.hook';
import { CourierBatchInputModal } from './components/courier-batch-input-modal.component';
import { CourierBatchReviewModal } from './components/courier-batch-review-modal.component';

export interface BatchImportCouriersActionProps {
  projectID: string;
  onAbort(): void;
  onSuccess(): void;
}

export function BatchImportCouriersAction(props: BatchImportCouriersActionProps) {
  const { state, handlers, units, loading } = useBatchImportCouriersAction(props);

  switch (state.step) {
    case 'review':
      return <CourierBatchReviewModal state={state} handlers={handlers} units={units} />;
    case 'input':
    default:
      return <CourierBatchInputModal state={state} handlers={handlers} loading={loading} />;
  }
}
